import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'

import NotFound from 'errorPages/NotFound'

import ChangePassword from '../../account/changePassword'
import { ROUTE_PATHS } from '../../common/routePaths'
import { MenuItem } from '../common/MenuItem'
import Prospects from './prospects'
import EmployeeCensus from './prospects/employeeCensus'
import Proposal from './prospects/proposal'

const { PROSPECTS_PATH, UPLOAD_EMPLOYEE_CENSUS_PATH, PROPOSAL_PATH } = ROUTE_PATHS

interface Props {}

export enum NaviationMapping {
  Prospects = 1,
  ChangePassword = 2,
  Proposal = 3,
  EmployeeCensus = 4,
}

export const navigationPathMapping = new Map<string, number>([[PROSPECTS_PATH, NaviationMapping.Prospects]])
export const menu = [
  {
    name: 'prospects',
    key: NaviationMapping.Prospects,
    path: PROSPECTS_PATH,
    component: Prospects,
  },
]

const Routes: React.FC<Props> = () => {
  let match = useRouteMatch()

  return (
    <Switch>
      <Route
        key={NaviationMapping.ChangePassword}
        path={ROUTE_PATHS.ICHRA_DECISION_TOOL_CHANGE_PASSWORD_PATH}
        component={ChangePassword}
      />
      <Route key={'Proposal'} path={`${match.path}/${PROPOSAL_PATH}`} component={Proposal} />
      <Route key={'EmployeeCensus'} path={`${match.path}/${UPLOAD_EMPLOYEE_CENSUS_PATH}`} component={EmployeeCensus} />

      {menu
        .sort((first, second) => second.key - first.key)
        .map((item: MenuItem) => (
          <Route key={item.key} path={`${match.path}/${item.path}`} component={item.component} exact />
        ))}

      <Route>
        <NotFound />
      </Route>
    </Switch>
  )
}

export default Routes
